/* Utility export comuni (TXT, ICS, XLSX, PDF) usate da piu pagine. */
import * as XLSX from 'xlsx';
import { saveFile } from './fileSave';

export function downloadTextFile(content: string, filename: string, mime = 'text/plain'): void {
  const blob = new Blob([content], { type: `${mime};charset=utf-8` });
  // saveFile gestisce browser (download) e app nativa (bridge -> condivisione).
  void saveFile(blob, filename, mime);
}

/** ICS (VCALENDAR) per calendario disponibilita' */
export function buildIcs(events: { date: string; status: string }[], userNick: string): string {
  const lines = [
    'BEGIN:VCALENDAR', 'VERSION:2.0',
    `PRODID:-//VVF Tracker//Disponibilita ${userNick}//IT`,
    'CALSCALE:GREGORIAN', 'METHOD:PUBLISH',
  ];
  for (const ev of events) {
    const d = ev.date.replace(/-/g, '');
    lines.push('BEGIN:VEVENT');
    lines.push(`UID:${d}-${userNick}@vvf`);
    lines.push(`DTSTART;VALUE=DATE:${d}`);
    lines.push(`DTEND;VALUE=DATE:${d}`);
    lines.push(`SUMMARY:${statusLabel(ev.status)}`);
    lines.push(`DESCRIPTION:Disponibilita VVF ${statusLabel(ev.status)}`);
    lines.push('END:VEVENT');
  }
  lines.push('END:VCALENDAR');
  return lines.join('\r\n');
}
function statusLabel(s: string): string {
  if (s === 'Available') return 'Disponibile';
  if (s === 'OnCall') return 'Reperibile';
  if (s === 'NotAvailable') return 'Non disponibile';
  return s;
}

/** Magazzino TXT raggruppato per categoria */
export function warehouseToTxt(items: { category: string; name: string; quantity: number; unit?: string; serialNumber?: string; expiry?: string }[],
  onlyWithSerial: boolean): string {
  const filtered = onlyWithSerial ? items.filter(i => i.serialNumber) : items;
  const byCat: Record<string, typeof filtered> = {};
  for (const i of filtered) { (byCat[i.category] ??= []).push(i); }

  const lines: string[] = [];
  lines.push(`MAGAZZINO VVF - export del ${new Date().toLocaleDateString('it-IT')}`);
  lines.push('='.repeat(60));
  lines.push('');
  for (const cat of Object.keys(byCat).sort()) {
    lines.push(`[${cat.toUpperCase()}] (${byCat[cat].length})`);
    for (const it of byCat[cat]) {
      const sn = it.serialNumber ? ` #${it.serialNumber}` : '';
      const exp = it.expiry ? ` scad ${it.expiry}` : '';
      lines.push(`  - ${it.name} (${it.quantity} ${it.unit ?? ''})${sn}${exp}`);
    }
    lines.push('');
  }
  return lines.join('\n');
}

/** Export XLSX generico da array di righe */
export function downloadXlsx<T>(rows: T[], sheetName: string, filename: string): void {
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  // NON XLSX.writeFile (download browser, ignorato dal WebView): generiamo il
  // buffer e passiamo da saveFile (browser download / bridge nativo).
  const buf = XLSX.write(wb, { type: 'array', bookType: 'xlsx' }) as ArrayBuffer;
  const mime = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  void saveFile(new Blob([buf], { type: mime }), filename, mime);
}
